import { render, staticRenderFns } from "./Time.vue?vue&type=template&id=5c513441&scoped=true&"
import script from "./Time.vue?vue&type=script&lang=js&"
export * from "./Time.vue?vue&type=script&lang=js&"
import style0 from "./Time.vue?vue&type=style&index=0&id=5c513441&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c513441",
  null
  
)

export default component.exports